



 const english_synonym_list = ""; /*"{federal government, national government}\n";+
  "{state government, provincial government}\n"+
  "{city planning, urban planning, regional planning, urban & regional planning}\n"+
  "{farm, farming, agriculture, agricultural}\n"+
  "{land records, property records, land administration}\n"+
  "{retailing, retail}\n"+
  "{road, street, highway}\n"+
  "{railroad, railway}\n"+
  "{port, maritime, harbor, sea lane, buoy, shipping}\n"+
  "{medicine, medical, health}\n"+
  "{electricity, electric}\n"+
  "{telecom, telecommunications}\n"+
  "{arcgis desktop, desktop arcgis, standalone arcgis, single-user arcgis, desktop gis, standalone gis, single-user gis, arcgis pro}\n"+
  "{arcgis for server, arcgis server, server arcgis, server-based arcgis, gis for server, server-based gis, enterprise gis, arcgis enterprise, enterprise arcgis}\n"+
  "{story map, story maps, storymap, storymaps}\n"+
  "{airport planning, airspace analysis, airport regulations, arcgis for aviation: airports}\n"+
  "{aviation charts, aviation charting, aeronautical charts, aeronautical charting, arcgis for aviation: charting}\n"+
  "{nautical charts, nautical charting, navigation charts, navigation charting, navigational charts, navigational charting, electronic navigational charts, ENC, ENCs,maritime data, S-57, AML, IENC, encrypted S-63, arccgis for maritime: charting}\n"+
  "{highway agency, highway agencies, roadways, linear referencing system, LRS, esri roads and highways}\n"+
  "{drone2map, drone 2 map, drone to map, drone, drones}\n"+
  "{16 bit, high color}\n"+
  "{3 color, rgb}\n"+
  "{3x3 window, focal window}\n"+
  "{4 color, cmyk}\n"+
  "{abs, absolute value}\n"+
  "{active theme, selectable layer}\n"+
  "{add theme, add data}\n"+
  "{addition, plus}\n"+
  "{adds table, delta tables}\n"+
  "{adjust, correct}\n"+
  "{adjust transformation, rubber sheeting}\n"+
  "{adrg, arc digitized raster graphics}\n"+
  "{aggregate, resample}\n"+
  "{ai, adobe illustrator}\n"+
  "{alias, alternate}\n"+
  "{align, adjust}\n"+
  "{allocate, network analyst solver, service area solver}\n"+
  "{angle, direction}\n"+
  "{anno, annotation, text}\n"+
  "{annotation subclass, annotation class}\n"+
  "{annotation target, annotation group}\n"+
  "{annotate, label}\n"+
  "{annulus, donut, doughnut, dounut, ring, toroid, torus}\n"+
  "{Archydro, arc hydro}\n"+
  "{arcinfo workstation coverage annotation, coverage annotation}\n"+
  "{arcplot, print}\n"+
  "{arcsde service, arcsde application server}\n"+
  "{arcview legend file, avl, arcview palette file, avp, style}\n"+
  "{ascii, american standard code for information interchange}\n"+
  "{aspect, orientation}\n"+
  "{asrp, arc standard raster product}\n"+
  "{attribute, property}\n"+
  "{attribute inspector, attributes dialog box}\n"+
  "{attribute query, select by attributes}\n"+
  "{attribute table, raster attribute table, table}\n"+
  "{aux, auxiliary file}\n"+
  "{avhrr, advanced very high resolution radiometer}\n"+
  "{backlink, direction}\n"+
  "{base table, business table}\n"+
  "{baseline shift, y offset}\n"+
  "{basin, watershed}\n"+
  "{behavior, behaviour}\n"+
  "{bil, band interleaved by line}\n"+
  "{bin, class}\n"+
  "{bip, band interleaved by pixel}\n"+
  "{bird's eye perspective, map perspective}\n"+
  "{bit depth, pixel depth}\n"+
  "{bit depth, color depth}\n"+
  "{bitmap, bmp, raster, grid, image, graticule, raster dataset}\n"+
  "{bloated annotation, inline annotation}\n"+
  "{blob, binary large object}\n"+
  "{block size, tile size}\n"+
  "{bookmark, spatial bookmark}\n"+
  "{boolean expression, true or false expression}\n"+
  "{break, split}\n"+
  "{bsq, band sequential}\n"+
  "{bulk, batch}\n"+
  "{business objects, crystal reports}\n"+
  "{cad, computer aided design}\n"+
  "{cadrg, compressed arc digitized raster graphics}\n"+
  "{callout, balloon callout}\n"+
  "{camera, observer}\n"+
  "{categorical, thematic}\n"+
  "{categories, unique values}\n"+
  "{cdl, network common data form language}\n"+
  "{cell, pixel}\n"+
  "{cell size, cell resolution, resolution, spatial resolution}\n"+
  "{cell statistics, local statistics}\n"+
  "{center, centre}\n"+
  "{centroid, center of ellipse}\n"+
  "{cf, climate and forecast}\n"+
  "{charts, graphs}\n"+
  "{check constraint, attribute domain}\n"+
  "{check in, synchronize}\n"+
  "{check out, check out check in, check out check in replication, disconnected editing}\n"+
  "{cib, controlled image base}\n"+
  "{clamp, pin}\n"+
  "{clamp to ground, pin to surface}\n"+
  "{clip, cookie cut, cookie cutter, cut}\n"+
  "{cnt, condition table}\n"+
  "{cogo, coordinate geometry}\n"+
  "{color, colour}\n"+
  "{colormap, pseudo color}\n"+
  "{column, field}\n"+
  "{combine, append}\n"+
  "{composite index, multicolumn index}\n"+
  "{conditional, con}\n"+
  "{config, configuration}\n"+
  "{config keyword, configuration keyword}\n"+
  "{conflate, edge match, merge}\n"+
  "{context menu, shortcut menu}\n"+
  "{contiguous, connected}\n"+
  "{continuous raster, surface map}\n"+
  "{contrast stretch, stretch}\n"+
  "{coordinate reference system, coordinate system, projection}\n"+
  "{corridor, least cost corridor}\n"+
  "{cost backlink, cost direction}\n"+
  "{cost grid, cost raster}\n"+
  "{cost path, least cost path, path of least resistance}\n"+
  "{cost surface, friction surface}\n"+
  "{cost weighted, cost distance}\n"+
  "{create flyby from path, move camera along path}\n"+
  "{cross reference database, cross ref database, schema, xref database, x ref database}\n"+
  "{curve, circular arc, fillet, tangent}\n"+
  "{Ds mapbook, dsmapbook, mapbook, map book}\n"+
  "{dangle, cul de sac, dangling arc}\n"+
  "{darcy flow, darcy velocity, darcyflow, groundwater flow}\n"+
  "{data depth, bit depth, pixel depth}\n"+
  "{data type, pixel type}\n"+
  "{dataframe, data frame}\n"+
  "{datum, geographic coordinate system}\n"+
  "{datum shift, datum transformation, geographic transformation}\n"+
  "{dba, database administrator}\n"+
  "{dbms, database management system}\n"+
  "{dde, ole}\n"+
  "{decompress, uncompress}\n"+
  "{deletes table, delta tables}\n"+
  "{dem, digital elevation model}\n"+
  "{depressionless dem, filled dem}\n"+
  "{destination, end point}\n"+
  "{digest, digital geographic information exchange standard}\n"+
  "{digitizer, digitizing tablet}\n"+
  "{direct connect, direct connection}\n"+
  "{discrete, discontinuous, thematic}\n"+
  "{display, render}\n"+
  "{distance units, display units}\n"+
  "{distributed geodatabase, geodatabase replication}\n"+
  "{division, divide}\n"+
  "{donut hole, multipart polygon}\n"+
  "{donut shaped, toroidal}\n"+
  "{doq, digital orthophoto quadrangle}\n"+
  "{doqq, digital orthophoto quadrangle quadrant}\n"+
  "{downsample, resample}\n"+
  "{draw, digitize}\n"+
  "{drg, digital raster graphic}\n"+
  "{dted, digital terrain elevation data}\n"+
  "{edge, segment}\n"+
  "{edge match, edge snap}\n"+
  "{edit cache, map cache}\n"+
  "{efl, license}\n"+
  "{ele, esri label engine}\n"+
  "{element, graphic}\n"+
  "{ellipsoid, spheroid}\n"+
  "{emf, enhanced meta file}\n"+
  "{environment settings, analysis environment}\n"+
  "{eps, encapsulated postscript}\n"+
  "{esri grid, grid}\n"+
  "{esri label engine, standard label engine}\n"+
  "{esu, license, registration}\n"+
  "{euclidean allocation, straight line allocation}\n"+
  "{euclidean direction, straight line direction}\n"+
  "{euclidean distance, as the crow flies, shortest distance, spread, straight line distance}\n"+
  "{extent, geographic constraint}\n"+
  "{extract by attribute, select by attribute}\n"+
  "{feature class, coverage, shapefile, featureclass, featureclasses, feature classes}\n"+
  "{feature linked, feature linked, featurelinked}\n"+
  "{feature linked annotation, linked annotation}\n"+
  "{filter, smooth, spatial convolution}\n"+
  "{finish, commit}\n"+
  "{flexlm, license manager}\n"+
  "{flip, horizontal flip}\n"+
  "{floating license, concurrent license}\n"+
  "{flow, drain}\n"+
  "{flowaccumulation, flow accumulation}\n"+
  "{flowdirection, flow direction}\n"+
  "{flowlength, flow length}\n"+
  "{focal, moving window, overlapping neighborhood, scan}\n"+
  "{focal analysis, focal functions}\n"+
  "{focal cell, processing cell}\n"+
  "{focal statistics, moving window statistics}\n"+
  "{fon, raster based font}\n"+
  "{font size, font height}\n"+
  "{format, file format}\n"+
  "{fuzzy tolerance, cluster tolerance}\n"+
  "{gcs, geographic coordinate systems}\n"+
  "{generalization, simplification}\n"+
  "{generalize, simplify}\n"+
  "{generalizing, data clean up}\n"+
  "{geodatabase, gdb}\n"+
  "{geodatabase history, geodatabase archiving}\n"+
  "{geography network, gis portal}\n"+
  "{geoprocessing, spatial analysis, gp}\n"+
  "{georeference, georeferencing, match, rectify}\n"+
  "{geostatistical analyst, ga}\n"+
  "{gif, graphics interchange format}\n"+
  "{gis, geographic information system}\n"+
  "{global analysis, global functions}\n"+
  "{globalid, global identifier}\n"+
  "{grab handles, selection handles}\n"+
  "{graphic text, map layout annotation}\n"+
  "{grayscale, single band}\n"+
  "{grid cell, cell}\n"+
  "{grid stack, multi band grid}\n"+
  "{group layer animation, group animation}\n"+
  "{group layers, nested layers}\n"+
  "{guid, global identifier, globally unique identifier}\n"+
  "{hdf, Hierarchical Data Format}\n"+
  "{heads up, onscreen}\n"+
  "{height, elevation}\n"+
  "{hf, horizontal factor}\n"+
  "{hide features, definition query}\n"+
  "{high pass filter, edge enhancement filter}\n"+
  "{highway shield, marker text background, text background}\n"+
  "{hillshade, shaded relief}\n"+
  "{hillshading, relief shading}\n"+
  "{history, archiving}\n"+
  "{horizontal scale, character width}\n"+
  "{hotlink, hyperlink}\n"+
  "{hrma, horizontal relative moving angle}\n"+
  "{html formatting tag, text formatting tag}\n"+
  "{id tool, identify tool}\n"+
  "{idw, inverse distance weighted}\n"+
  "{ihs, intensity hue saturation}\n"+
  "{img, imagine}\n"+
  "{indexed color, paletted}\n"+
  "{inflated annotation, inline annotation}\n"+
  "{info tool, identify tool}\n"+
  "{internet data, service}\n"+
  "{intersectarcs, planarize}\n"+
  "{inverse tool, update cogo attributes}\n"+
  "{jaggy, aliased}\n"+
  "{jp2, jpeg2000}\n"+
  "{jpeg, joint photographic experts group}\n"+
  "{jscript, java script}\n"+
  "{kernel, convolution kernel, filter}\n"+
  "{keyboard shortcut, shortcut, shortcut key}\n"+
  "{kml, keyhole markup language}\n"+
  "{label, text}\n"+
  "{label text, label string}\n"+
  "{layer, layer file}\n"+
  "{leader line, line callout}\n"+
  "{leading, line spacing}\n"+
  "{least cost, least accumulative cost}\n"+
  "{letter spacing, character spacing}\n"+
  "{level of detail, lod, level of detail}\n"+
  "{line of sight, los, line of sight}\n"+
  "{link, control point}\n"+
  "{load, import}\n"+
  "{local analysis, local functions, per cell functions}\n"+
  "{lotarea, cogo area}\n"+
  "{lower case, noncapital}\n"+
  "{low pass filter, averaging filter, smoothing filter}\n"+
  "{lut, lookup table}\n"+
  "{lyr, layer, layer file}\n"+
  "{ma, military analyst}\n"+
  "{majority, mode, most frequent, most often}\n"+
  "{make, create}\n"+
  "{map, layout, map sheet}\n"+
  "{map algebra, grid algebra}\n"+
  "{map annotation, mxd annotation}\n"+
  "{map document annotation, map annotation, mxd annotation}\n"+
  "{map element, map surround}\n"+
  "{map server, arcgis server map server}\n"+
  "{maptips, popups}\n"+
  "{mask, analysis mask, halo}\n"+
  "{max, maximum}\n"+
  "{maximum cost distance, threshold distance}\n"+
  "{maximum likelihood classification, mlc}\n"+
  "{mean, average}\n"+
  "{med, median}\n"+
  "{metadata service, gis portal}\n"+
  "{mgrs, military grid reference system}\n"+
  "{middle, center, centroid}\n"+
  "{migrate, upgrade}\n"+
  "{military analyst, military tools}\n"+
  "{min, minimum}\n"+
  "{minority, least frequent, least often}\n"+
  "{mle, maplex label engine}\n"+
  "{model, tool}\n"+
  "{moma, multiple output map algebra}\n"+
  "{monochrome, 1 bit}\n"+
  "{multidimensional data, netcdf}\n"+
  "{multiplication, times}\n"+
  "{multivariate statistics, multivariate analysis}\n"+
  "{multiversion view, multiversioned view}\n"+
  "{mxd, map document}\n"+
  "{mxt, map template}\n"+
  "{nearest neighbor, resampling}\n"+
  "{neatline, border}\n"+
  "{ned, national elevation data}\n"+
  "{neighborhood functions, focal functions}\n"+
  "{neighborhood statistics, focal statistics}\n"+
  "{netcdf, network common data form}\n"+
  "{nitf, national image transfer format}\n"+
  "{nodata, missing value}\n"+
  "{normal mxt, normal template}\n"+
  "{oid, object id, objectid}\n"+
  "{open gis consortium, ogc}\n"+
  "{operators, functions}\n"+
  "{options, settings}\n"+
  "{orthography, orthographic, orthophoto, orthographic}\n"+
  "{orthorectified, ortho corrected}\n"+
  "{otf, opentype}\n"+
  "{overlap, integrate}\n"+
  "{overshoot, dangle}\n"+
  "{page setup, page and print setup}\n"+
  "{panchromatic sharpening, pan sharpening}\n"+
  "{particletrack, particle track}\n"+
  "{path, path name, pathname}\n"+
  "{pca, principal component analysis}\n"+
  "{pcs, projected coordinate systems}\n"+
  "{pdf, portable document format}\n"+
  "{pen tool, ink tool}\n"+
  "{pencil tool, sketch tool}\n"+
  "{perimeter, boundary, sum of lengths}\n"+
  "{pfm, type 1 font}\n"+
  "{plot, digitize}\n"+
  "{png, portable network graphics}\n"+
  "{porouspuff, porous puff}\n"+
  "{postscript font, type 1 font}\n"+
  "{pour points, outlet}\n"+
  "{precedence, order of evaluation}\n"+
  "{precision, resolution}\n"+
  "{print, printing}\n"+
  "{printer, plotter}\n"+
  "{privilege, permission}\n"+
  "{prn, print ready file}\n"+
  "{project, map document}\n"+
  "{projection, coordinate system, spatial reference}\n"+
  "{promote records, show selected records}\n"+
  "{ps, postscript}\n"+
  "{pyramids, reduced resolution datasets}\n"+
  "{random, rand}\n"+
  "{rank, dimensionality}\n"+
  "{raster catalog item, raster catalog row}\n"+
  "{raster dataset band, raster band}\n"+
  "{raster footprints, raster wireframe}\n"+
  "{reclass, reclassify, recode}\n"+
  "{recover, restore}\n"+
  "{red box, red bounding box}\n"+
  "{refresh, redraw}\n"+
  "{register, georeference}\n"+
  "{render, draw}\n"+
  "{rescale, respace}\n"+
  "{resolution, spatial resolution}\n"+
  "{rgb, red green blue}\n"+
  "{root mean square, r m s, rms}\n"+
  "{round down, floor}\n"+
  "{round up, ceil}\n"+
  "{row, record}\n"+
  "{rpc, rational polynomial coefficient}\n"+
  "{rpf, raster product format}\n"+
  "{rrd, reduced resolution dataset}\n"+
  "{same as printer, use printer paper settings}\n"+
  "{script, macro, tool}\n"+
  "{sdc, smart data compression}\n"+
  "{sde user, arcsde administrator}\n"+
  "{select, highlight}\n"+
  "{select by theme, select by location}\n"+
  "{semivariogram, empirical semivariogram}\n"+
  "{separate, explode}\n"+
  "{shadow, drop shadow}\n"+
  "{shape, feature}\n"+
  "{shared edit tool, topology edit tool}\n"+
  "{shortest path, least cost path}\n"+
  "{shp, shapefile, shape file}\n"+
  "{shrink text, font reduction}\n"+
  "{sink, depression, pit}\n"+
  "{sketch, digitize}\n"+
  "{sle, standard label engine}\n"+
  "{snappour, snap pour point}\n"+
  "{snaptips, popups}\n"+
  "{solar radiation, insolation}\n"+
  "{soma, single output map algebra}\n"+
  "{source, starting point, source raster}\n"+
  "{spatial autocorrelation, autocorrelation}\n"+
  "{spatial index, grid index}\n"+
  "{spatial join, join by location}\n"+
  "{spectral value, digital number}\n"+
  "{spike, peak}\n"+
  "{split, cut, proportion}\n"+
  "{spot elevation, spot height}\n"+
  "{sql select, select by attributes}\n"+
  "{standard annotation, standalone annotation}\n"+
  "{std, standard devation, stdev}\n"+
  "{stereo pair, stereoscopic pair}\n"+
  "{stop refreshing, pause drawing}\n"+
  "{stream intersection, stream junction, stream node}\n"+
  "{streamorder, stream order}\n"+
  "{streamshape, stream to feature}\n"+
  "{stretch words, character spacing, word spacing}\n"+
  "{string, text}\n"+
  "{structured query language, sql}\n"+
  "{subtraction, minus}\n"+
  "{suitability, site selection}\n"+
  "{sum, total}\n"+
  "{svg, scalable vector graphics, svgz}\n"+
  "{symbol, style, symbology}\n"+
  "{symbolize, draw}\n"+
  "{symbolset, style}\n"+
  "{tabulate area, cross tabulated area, summarize zones}\n"+
  "{temporal animation, animation through time, time animation}\n"+
  "{terrain, terrain dataset}\n"+
  "{text background, balloon callout, line callout, marker text background}\n"+
  "{text fill pattern, 3d texture fill symbol, gradient fill symbol, line fill symbol, marker fill symbol, picture fill symbol, simple fill symbol}\n"+
  "{theme, layer}\n"+
  "{thiessen, voronoi}\n"+
  "{threshold angle, cut angle}\n"+
  "{tic, control point}\n"+
  "{tiff, tag image file format}\n"+
  "{time animation, animation through time}\n"+
  "{time layer, temporal layer}\n"+
  "{time stamp, time value}\n"+
  "{time text, time display}\n"+
  "{tin, 3d Analyst, triangular irregular network}\n"+
  "{topo to raster, topo to raster by file, topogrid}\n"+
  "{topology, coincidence, coincident, shared geometry}\n"+
  "{tracking, character spacing, letter spacing}\n"+
  "{transform, adjust, georeference}\n"+
  "{trend interpolation, global polynomial interpolation}\n"+
  "{truecolor, 24 bit, true color}\n"+
  "{ttc, true type collection}\n"+
  "{ttf, truetype}\n"+
  "{uml, unified modeling language}\n"+
  "{unavailable, disabled, grayed out, greyed out, gray, grey}\n"+
  "{unc, universal naming convention, uniform naming convention}\n"+
  "{undershoot, dangle}\n"+
  "{unmanaged raster catalog, referenced raster catalog}\n"+
  "{unplaced, hidden}\n"+
  "{update, upgrade}\n"+
  "{upper case, capital}\n"+
  "{usrp, utm ups standard raster product}\n"+
  "{validate, check}\n"+
  "{value attribute table, raster attribute table, vat, rat}\n"+
  "{vb script, visual basic script}\n"+
  "{vertex, corner}\n"+
  "{vertexes, vertices}\n"+
  "{vf, vertical factor}\n"+
  "{view frame, data frame}\n"+
  "{viewshed, visibility, observer points}\n"+
  "{vpf, vector product format}\n"+
  "{vrms, vertical relative moving angle}\n"+
  "{vvt, valid value table}\n"+
  "{warp, georeference, transform}\n"+
  "{watershed, catchment, contributing area}\n"+
  "{watershed boundaries, drainage divides}\n"+
  "{web map service, wms, web mapping service}\n"+
  "{wedge, pie slice, pie shape}\n"+
  "{weedtolerance, stream mode}\n"+
  "{weighted distance, cost distance}\n"+
  "{where clause, attribute query}\n"+
  "{widen, copy parallel}\n"+
  "{window, dialog box}\n"+
  "{windows authentication, os authentication}\n"+
  "{workspace, folder}\n"+
  "{worm's eye perspective, cell perspective}\n"+
  "{x y, coordinate, coordinates, xy}\n"+
  "{xor, exclusive or}\n"+
  "{z value, elevation, z value}\n"+
  "{zonal analysis, zonal functions}" */
window._searchSynonyms = {
    list:english_synonym_list,
    work:{},
    data:[]
};


function searchSynonyms(_synonym_list){
  const synonym_list = _synonym_list || '';
  var data = {
      synonym_text_groups_array: synonym_list.replace(/\s*{/g,"\n{").trim().split(/\n/),
      synonym_array_groups_array: [],
      synonym_ordered_array: []
  };
  // create array of synonym lists from english_synonym_list
  data.synonym_text_groups_array
    .forEach(function(i){data.synonym_array_groups_array.push(i.replace(/[{}]/g,'').replace(/\s*,\s*/g,",").split(","))});

  // index individual synonym strings in data.synonym_text_groups_array
  for(var xi = 0 ; xi < data.synonym_array_groups_array.length ; xi++){
      for(var xii = 0, xarr =  data.synonym_array_groups_array[xi] ; xii < xarr.length ; xii++) {
          data.synonym_ordered_array.push({index_1:xi, index_2:xii, val:xarr[xii]})
      }
  }

  // ordered by string.length descending.
  data.synonym_ordered_array.sort(function(a,b){
    parseInt(b.val.length) - parseInt(a.val.length)
  });

  window._searchSynonyms.work = data;

  // hide text in quotes or parentheses
  function _removePhraseGroups(str){
    var noPhrases = str || "";
    noPhrases = noPhrases
      .replace(/\(([^\)]+)?\)/g, replacer)
      .replace(/\'([^\']+)?\"/g, replacer)
      .replace(/\"([^\"]+)?\"/g, replacer);

    function replacer(match){
      var replaceWith = "";
      for(var i=0 ; i<match.length ; i++){
          replaceWith += "_";
      }
      return replaceWith
    }
    return noPhrases;
  }

  // match whole word - 'road' matches 'road', not 'railroad'
  function _matchesWholeSubString(_s,_t){
    var s = _s || '';
    var t = _t || '';
    var searchString = _removePhraseGroups(s.toLowerCase()),
      term = t.toLowerCase() ;

    if(searchString == '' || term == '') return false;
    if(searchString == term){
        return true;
    }

    var _start = searchString.indexOf(term);
    if(_start > -1){
        var _end = _start+term.length,
          _matchStringAndPrefix = searchString.substring(0,_end),
          _matchStringAndSuffix = searchString.substring(_start),
          _segment = searchString.substring(_start, _end);

        if(_matchStringAndPrefix.length > _segment.length  && _matchStringAndPrefix.substr(_start-1,1) !== ' '){
            return false;
        }
        else if(_matchStringAndSuffix.length > _segment.length  && _matchStringAndSuffix.substr(term.length, 1) !== ' '){
            return false;
        }
        else if(_segment == term){
            return true;
        }
        else{
            return false;
        }
        return false;
    }
    return false;
  }
  // create synonymData object based on user input search string
  function _getSearchTermSynonymData(_searchString){

    var synonymData = [];
    searchString = _searchString.toLowerCase();

    // ordered by string.length descending.
    data.synonym_ordered_array.forEach(function(syn) {
      var synonym_term = syn.val.toLowerCase();

      // hide text in quotes or parentheses
      if(_matchesWholeSubString(searchString,synonym_term)){
        var synonym_list = data.synonym_array_groups_array[syn.index_1],
          _list = '"'+synonym_list.join('" OR "')+'"',
          _loc = {start:searchString.indexOf(synonym_term),length:synonym_term.length};
        synonymData.push({list:_list,loc:_loc,synonyms:synonym_list,match:synonym_term});
        searchString = searchString.replace(RegExp(synonym_term, "g"),"").trim()
      }
    });

    synonymData.sort(function(a,b){
        return a.loc.start < b.loc.start;
    });

    window._searchSynonyms.data = synonymData;
    return synonymData;
  }

  return  {
    getSearchTermSynonymData : function(_searchString,_queryFormat){

      var searchString = _searchString || ''
      var queryFormat = _queryFormat || 1;

      var query = searchString,
        synonyms = [],
        data = _getSearchTermSynonymData(query);

      data.forEach(function(item){

          synonyms.push({name:item.match,match:{string:item.match,location:item.loc},list:item.synonyms,textList:item.synonyms.join(', ')});
          var left = query.substring(0,item.loc.start),
            right = query.substring(item.loc.start+item.loc.length);

          if(queryFormat == 1){
             // query = `${left}(${item.list})${right}`;
              query = left+'('+item.list+')'+right;
          }
          else if(queryFormat == 2){
              // query = `${left}(${item.list})${right} OR ("${searchString}")`;
              query = left+'('+item.list+')'+right+' OR ("'+searchString+'")';
          }
          else{
              query = searchString;
          }

      });
      return {
          searchStringWithSynonyms:query,
          searchString:searchString,
          synonyms:synonyms.reverse(),
          length:data.length,
          applySynonyms:(queryFormat ? true : false)
      };
    }
  };
}